import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import template from './ns-playground-page.html';

import '@nuskin/ns-style-elements';

/**
 * <p>ns-playground-page bootstraps a page in the playground.</p>
 *
 */
export class NsPlaygroundPage extends PolymerElement {
    constructor() {
        super();
    }

    static get is() {
        return "ns-playground-page";
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get properties() {
        return {
            /**
             * Indicates whether the overlay is currently open or not
             */
            opened: {
                type: Boolean,
                value: false
            }
        }
    }

    ready() {
        super.ready();
    }

    /**
     * Display the overlay and prevent the background from scolling
     */
    test() {
    }

}
customElements.define(NsPlaygroundPage.is, NsPlaygroundPage);
